import PricebookItemEditor from "./PricebookItemEditor";

export default PricebookItemEditor;
